const DEFAULT_IMAGE =
  "https://ik.imagekit.io/teofx8bxs/tr:f-webp,h-auto,w-auto/Website%20Img/mascot_image1678942204.png";

const metaConfig = [
  {
    path: "/health-insurance",
    title: "Health Insurance & Buy Medical Insurance Plans Online | Beema1",
    description:
      "Compare and buy the best health insurance plans online with Beema1. Get affordable medical insurance plans tailored for you, your family, and senior loved ones with expert support.",
    keywords: "Health Insurance, Buy Medical Insurance Plans",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/health-insurance/health-compare-quotes",
    title: "Compare Health Insurance Plans Online & Get Quotes | Health Policy",
    description:
      "Quickly compare health insurance plans online and get health insurance quotes online to choose the right health insurance policy for you and your family. Fast, free, and easy!",
    keywords:
      "Get health insurance quotes, Compare Health Insurance Plans Online, Health Insurance Policy",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/health-insurance/health-co-payment",
    title: "What Is Copayment in Health Insurance? Co-Payment Meaning & Plans",
    description:
      "Understand what is copayment in health insurance, the health insurance copay meaning, and how health insurance co payment works. Compare health insurance with copayment before you choose.",
    keywords:
      "what is copayment in health insurance, health insurance with copayment, health insurance copay meaning, health insurance co payment",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/health-insurance/parents-health-insurance",
    title: "Parents Health Insurance in Kolkata | Buy Best Medical Plans",
    description:
      "Looking to buy parents health insurance in West Bengal? Compare the best parents health insurance in Kolkata, including trusted parents medical insurance and coverage for ageing parents.",
    keywords:
      "parents health insurance in Kolkata, buy parents health insurance in west Bengal, best parents health insurance in Kolkata, parents medical insurance in Kolkata",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/health-insurance/cashless-health-insurance",
    title:
      "Cashless Health Insurance Plans in Kolkata | Best Cashless Mediclaim",
    description:
      "Looking for the best cashless health insurance in Kolkata? Compare and buy cashless health insurance plans in West Bengal with wide hospital networks and hassle-free claims.",
    keywords:
      "Cashless Health Insurance Plans in Kolkata, Best Cashless Mediclaim Kolkata, Cashless Health Insurance in Kolkata",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/health-insurance/health-clame-settelment",
    title:
      "Health Insurance Claim Settlement Ratio in India – Latest Insurer Data",
    description:
      "Understand health insurance claim settlement ratios in India, why they matter, and how insurer performance impacts your claim experience before choosing a policy.",
    keywords:
      "health insurance companies claim settlement ratio, Mediclaim claim settlement ratio India, health insurance claim settlement ratio India",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/health-insurance/family-health-insurance",
    title:
      "Family Health Insurance Plans in Kolkata for Complete Medical Cover",
    description:
      "Protect your loved ones with family health insurance in Kolkata. Explore flexible family medical insurance plans in West Bengal offering cashless care, wide hospital networks, and reliable claim support.",
    keywords:
      "Family Health Insurance, Family Health Insurance Plans, Family Medical Insurance, Family Medical Cover",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/health-insurance/critical-illness-insurance",
    title:
      "Critical Illness Insurance in Kolkata | Health Insurance with Coverage",
    description:
      "Protect yourself and your family with critical illness insurance. Explore critical illness medical insurance in Kolkata and health insurance with critical illness cover for financial security during major health events.",
    keywords:
      "critical illness insurance, critical illness medical insurance in Kolkata, health insurance with critical illness cover",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/health-insurance/health-topup-plan",
    title: "Health Insurance Top Up Plan in Kolkata | Family Coverage Options",
    description:
      "Enhance your protection with a health insurance top up plan. Explore top up mediclaim in Kolkata, health insurance top up plans for family, and top up health insurance coverage for larger medical expenses.",
    keywords:
      "health Insurance top up plan, top up mediclaim in Kolkata, health insurance top up plans for family, top up health insurance coverage",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/health-insurance/senior-citizen-insurance",
    title: "Senior Citizen Health Insurance Plans Kolkata | Buy Coverage Today",
    description:
      "Explore the best senior citizen health insurance plans in Kolkata. Buy senior citizen health insurance in Kolkata with wide hospital networks, cashless claims, and comprehensive coverage for peace of mind.",
    keywords:
      "senior citizen health insurance plans Kolkata, buy senior citizen health insurance in kolkata",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/health-insurance/individual-health-insurance",
    title:
      "Individual Health Insurance in Kolkata | Personal Health Insurance Plans",
    description:
      "Secure your health with individual health insurance in Kolkata. Buy individual health insurance or choose a personal health insurance plan or individual mediclaim policy for comprehensive coverage and cashless claims.",
    keywords:
      "individual health insurance in Kolkata, buy individual health insurance, personal health insurance plans, individual mediclaim policy",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/term-insurance",
    title: "Buy Term Insurance Plan in Kolkata | Best Term Insurance Policy",
    description:
      "Secure your family’s future—buy term insurance plan in Kolkata with flexible coverage and affordable premiums. Compare options to choose the best term insurance policy that fits your needs.",
    keywords: "buy term insurance plan in Kolkata, best term insurance policy",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/car-insurance",
    title: "Buy Car Insurance in Kolkata | Renew Car Insurance Online Easily",
    description:
      "Buy car insurance in Kolkata or renew car insurance online in minutes. Get the right car insurance policy with quick car insurance renewal online, competitive premiums, and smooth claims.",
    keywords:
      "buy car insurance in Kolkata, renew car insurance, car insurance policy, car insurance renewal online",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/bike-insurance",
    title: "Buy Bike Insurance in Kolkata | Renew Two Wheeler Policy Online",
    description:
      "Buy bike insurance in Kolkata or renew bike insurance instantly. Get a reliable two wheeler insurance policy or instant bike insurance policy online with quick issuance and smooth claims.",
    keywords:
      "buy bike insurance in Kolkata, two wheeler insurance policy, instant bike insurance policy, renew bike insurance",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/blogs",
    title: "Insurance Blogs & Guides | Beema1",
    description:
      "Read the latest insurance blogs, guides, and expert insights on health, car, bike, and term insurance at Beema1.",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/career",
    title: "Careers at Beema1 | Join Our Insurance Experts Team",
    description:
      "Explore career opportunities at Beema1. Join our growing insurance team and build a rewarding career.",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/about-us",
    title: "About Beema1 | Trusted Insurance Experts in Kolkata",
    description:
      "Learn more about Beema1, our mission, values, and how we help customers choose the right insurance policies.",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/contactUs",
    title: "Contact Beema1 | Insurance Support & Expert Assistance",
    description:
      "Get in touch with Beema1 for insurance support, policy assistance, and expert guidance.",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/calculator",
    title: "Insurance Premium Calculator | Beema1",
    description:
      "Use Beema1’s insurance calculators to estimate premiums and choose the right coverage for your needs.",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/termsandcondition",
    title: "Terms & Conditions | Beema1",
    description:
      "Read Beema1’s terms and conditions governing the use of our website and insurance services.",
    image: DEFAULT_IMAGE,
  },

  {
    path: "/privacy-policy",
    title: "Privacy Policy | Beema1",
    description:
      "Understand how Beema1 collects, uses, and protects your personal information.",
    image: DEFAULT_IMAGE,
  },
  {
    path: "/",
    title:
      "Beema1 | General & Health Insurance Company in Kolkata | Car, Bike & Term Insurance",
    description:
      "Looking for a trusted general insurance company in Kolkata? Compare health, car, bike & term insurance plans with expert guidance and choose the right policy for your needs.",
    keywords:
      "General Insurance Company in Kolkata, Health Insurance Company in Kolkata, Car Insurance Company in Kolkata, Terms insurance company, Bike Insurance Company",
    image: DEFAULT_IMAGE,
  },
];

export default metaConfig;
